const handleQrBlocks = (engine, { isRosterLeague, isPagePublished, qrImageUrl }) => {
  const allQrIds = engine.block.findByKind('qrimage')
  if (allQrIds.length === 0) { return }

  if (!isRosterLeague && isPagePublished && qrImageUrl) {
    allQrIds.forEach((qrId) => {
      const imageFill = engine.block.createFill('image')
      engine.block.setString(imageFill, 'fill/image/imageFileURI', qrImageUrl)
      engine.block.setFill(qrId, imageFill)
    })
  } else {
    allQrIds.forEach((qrId) => {
      engine.block.destroy(qrId)
    })
  }
}

export default handleQrBlocks
